document.addEventListener('click', function (e) {
  var toggle = e.target.closest('.urb-contact__dept-toggle');
  if (!toggle) return;
  var item = toggle.closest('.urb-contact__dept');
  var list = toggle.closest('.urb-contact__depts');
  if (!item || !list) return;
  var wasOpen = item.classList.contains('is-open');
  list.querySelectorAll('.urb-contact__dept.is-open').forEach(function (el) {
    el.classList.remove('is-open');
    var b = el.querySelector('.urb-contact__dept-toggle');
    if (b) b.setAttribute('aria-expanded', 'false');
  });
  if (!wasOpen) {
    item.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
  }
});
